import React from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import i18n from '../i18n';

/**
 * Custom confirmation dialog using react-toastify
 * @param {string} message - The confirmation message
 * @param {function} onConfirm - Function to call when confirmed
 * @param {string} confirmButtonText - Text for the confirm button (defaults to translated "Yes")
 * @param {string} cancelButtonText - Text for the cancel button (defaults to translated "No")
 */
const confirmDialog = ({ 
  message, 
  onConfirm, 
  confirmButtonText, 
  cancelButtonText 
}) => {
  // Use translated defaults if not provided
  const confirmText = confirmButtonText || i18n.t('common.yes', 'Yes');
  const cancelText = cancelButtonText || i18n.t('common.no', 'No');
  
  // Create a promise that will be resolved when the user makes a choice
  return new Promise((resolve) => {
    const toastId = toast.info(
      ({ closeToast }) => (
        <div>
          <p className="mb-3">{message}</p>
          <div className="d-flex justify-content-end">
            <button 
              className="btn btn-sm btn-secondary me-2" 
              onClick={() => {
                closeToast();
                resolve(false);
              }}
            >
              {cancelText}
            </button>
            <button 
              className="btn btn-sm btn-primary" 
              onClick={() => {
                closeToast();
                onConfirm();
                resolve(true);
              }}
              autoFocus
            >
              {confirmText}
            </button>
          </div>
        </div>
      ),
      {
        position: "top-center",
        autoClose: false,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: false,
        closeButton: false,
        onClose: () => resolve(false)
      }
    );
  });
};

export default confirmDialog;
